import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { ErrorView } from './ErrorView'
import { captureError } from '@/utils/sentry'

interface UnknownErrorProps {
  error: any
  fullScreen?: boolean
}

export function UnknownError({ error, fullScreen }: UnknownErrorProps) {
  const navigate = useNavigate()

  // biome-ignore lint/correctness/useExhaustiveDependencies: no explanation
  useEffect(() => {
    captureError(error)
  }, [])

  return <ErrorView onReload={() => navigate({ to: '.' })} fullScreen={fullScreen} />
}
